export default "__VITE_ASSET__Bf_vv8J1__"